import { receiveNumber, receiveString } from "../../../../controllers/adapters/receives"

/**
 * Formatea `2026-04-10 08:57:32.28026` -> `10/04/2026`
 */
const formatoFecha = (valor: any) => {

    const fechaParte = receiveString(valor).split(' ')[0]

    const [anio, mes, dia] = fechaParte.split('-')

    return anio && mes && dia ? `${dia}/${mes}/${anio}` : receiveString(valor)
}

/**
 * Mapea una fila del WS (prefijo `no_*`) a la estructura interna de noticia.
 */
const schemaNoticia = (item: any = {}) => ({

    id: receiveString(item.no_id_noticia),
    titulo: receiveString(item.no_titulo),
    contenido: receiveString(item.no_noticia),
    resumen: receiveString(item.no_descripcioncorta),
    imagen: receiveString(item.urlimagen || item.no_imagen),
    enlace: receiveString(item.no_enlace),
    fecha: formatoFecha(item.no_fmodificacion),
    seccion: receiveString(item.no_seccion),
    tipo: receiveString(item.no_tipo),
    publicada: receiveString(item.no_publicar),
})

/**
 * Extrae el listado de la respuesta del WS (viene en `data`).
 */
const extraerLista = (data: any): any[] => {

    if (!data) return []

    const lista = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : [])

    return lista.filter((item: any) => item && typeof item === 'object' && item.no_id_noticia)
}

/**
 * Recupera la primera noticia de la respuesta del WS (para el detalle),
 * esté en `data`, `noticia`, `contenido`, ... o directamente el objeto.
 */
const extraerPrimera = (data: any): any => {

    if (!data) return {}

    if (Array.isArray(data)) return data[0] || {}

    for (const clave of ['data', 'noticia', 'contenido', 'result', 'items']) {

        if (Array.isArray(data?.[clave]) && data[clave].length > 0) return data[clave][0]

        if (data?.[clave] && typeof data[clave] === 'object' && data[clave].no_id_noticia) return data[clave]
    }

    return data.no_id_noticia ? data : {}
}

const NoticiasAdapters = {

    // GET {base}/integraWeb.php?accion=obtener_noticias&no_seccion=700&page=N
    // La paginación viene en el objeto `Apag` de la respuesta.
    GET_NOTICIAS: {

        send: {

            schema: function (item: any = {}) {

                return {
                    accion: item.accion || 'obtener_noticias',
                    no_seccion: item.no_seccion || 700,
                    ...item,
                }
            },

            adapter: function (data: any) {

                const item = this.schema(data)

                return {
                    ...item
                }
            }
        },

        receive: {

            schema: schemaNoticia,

            adapter: function (data: any) {

                const items = extraerLista(data).map((item: any) => this.schema(item))

                const paginacion = data?.Apag || {}

                return {
                    items,
                    paginacion: {
                        page: receiveNumber(paginacion.page),
                        total: receiveNumber(paginacion.total),
                        last_page: receiveNumber(paginacion.last_page),
                        numregistros: receiveNumber(paginacion.numregistros),
                    }
                }
            }
        },
    },

    // GET {base}/integraWeb.php?accion=obtener_noticias&no_id_noticia=N
    // Se usa en el modal de previsualización para obtener el contenido completo.
    GET_NOTICIA: {

        send: {

            schema: function (item: any = {}) {

                return {
                    accion: item.accion || 'obtener_noticias',
                    no_id_noticia: item.no_id_noticia ?? item.id,
                    ...item,
                }
            },

            adapter: function (data: any) {

                const item = this.schema(data)

                return {
                    ...item
                }
            }
        },

        receive: {

            schema: schemaNoticia,

            adapter: function (data: any) {

                const noticia = this.schema(extraerPrimera(data))

                return {
                    data: noticia,
                }
            }
        },
    },
}

export {
    NoticiasAdapters
}